import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from './logo.svg';
import unified_streaming from './unified_streaming.svg';
import green_ok from './Check_green_icon.svg';
import yellow_warning from './yellow_warning.svg';
import red_ko from './red-x.svg';
import crash from './crash.svg';

// Automatic generation of API client from openapi.json hosted on the backend
import OpenAPIClientAxios from 'openapi-client-axios';
import React from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ProgressBar from 'react-bootstrap/ProgressBar';
import Spinner from 'react-bootstrap/Spinner';
import Collapse from 'react-bootstrap/Collapse';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Alert from 'react-bootstrap/Alert';
import Tooltip from 'react-bootstrap/Tooltip';
import { OverlayTrigger } from 'react-bootstrap';
// Confusing name for this project :) This just validates that a string is
// a valid URL. Used from the UI to validate input.
import validator from 'validator';
import { withRouter } from "react-router-dom";
import { CopyToClipboard } from 'react-copy-to-clipboard';

import jsonview from '@pgrabovets/json-view';
import { useRef, useEffect } from 'react';


// Default value will be used at develop time when running npm start and 
// must match the BACKEND_PORT value used in the docker-compose .env file
const DEFAULT_API_BASE_URL = "http://localhost:3001";
const DEFAULT_GIT_REVISION = 'Dev'

const VALID_FILES_AND_FORMATS = {
    ".mp4": 'mp4',
    ".cmfv": 'mp4',
    ".cmfa": 'mp4',
    ".cmfm": 'mp4',
    ".cmft": 'mp4',
    ".ismv": 'mp4',
    ".isma": 'mp4',
    ".ismt": 'mp4',
    ".mpd": 'mpd'
};


// Disable console log on production
if (process.env.NODE_ENV === 'production') {
    console.log = function () { };
}

function getApiBaseUrl() {
    if (process.env.REACT_APP_API_BASE_URL) {
        return process.env.REACT_APP_API_BASE_URL;
    }
    else {
        return DEFAULT_API_BASE_URL;
    };
}

function getGitRevision() {
    if (process.env.REACT_APP_GIT_REVISION) {
        return process.env.REACT_APP_GIT_REVISION;
    }
    else {
        return DEFAULT_GIT_REVISION;
    };
}

function folder_to_name(descriptors, folder) {
    for (var i = 0; i < descriptors.length; i++) {
        if (descriptors[i].folder === folder) {
            return descriptors[i].name;
        }
    }
}

function get_descriptor_by_name(descriptors, name) {
    for (var i = 0; i < descriptors.length; i++) {
        if (descriptors[i].name === name) {
            return descriptors[i];
        }
    }
}

const API_BASE_URL = getApiBaseUrl();
console.log('API BASE URL is ' + API_BASE_URL);
const api = new OpenAPIClientAxios({ definition: API_BASE_URL + '/openapi.json' });
api.init();

const DEFAULT_FORMAT = 'MP4'
const DEFAULT_SUITE = "Best Practices"


class UploadButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedFile: null,
            uploadedFileMessage: null,
            uploadInProgress: false,
            uploadProgress: 0,
            browse_disabled: false
        }
    }

    async dumpUploadProgress(progressEvent) {
        this.setState({ uploadProgress: Math.round((100 * progressEvent.loaded) / progressEvent.total) })
    }

    onUrlTyping(value) {
        console.log("called onUrlTyping")
        let input_url = document.getElementById('input_url');
        if (validator.isURL(input_url.value, { require_protocol: true })) {
            var fileExt = `.${input_url.value.split('.').pop()}`;
            if (fileExt) {
                this.updateFormatBasedOnExtension(fileExt);
            }
            this.setState({ browse_disabled: true })
            this.props.onFileUploaded(
                input_url.value,
                input_url.value
            );
        }
        else {
            this.setState({ browse_disabled: false })
            this.props.onFileUploaded(
                null,
                null
            );
        }
    }

    openBrowseDialog() {
        let input = document.getElementById('inputGroupFile03');
        input.click();
    }

    updateFormatBasedOnExtension(value) {
        console.log(value);
        let extension = value.slice(1).toUpperCase();
        var selected_format = get_descriptor_by_name(this.props.formats, extension);
        if (selected_format) {
            this.props.onSelectedFormat(selected_format);
        }
    }

    async onUploadClicked(value) {
        if (value) {
            let file = value.target.files[0];
            var fileExt = `.${file.name.split('.').pop()}`;
            if (fileExt) {
                this.updateFormatBasedOnExtension(fileExt);
            }
            let input_url = document.getElementById('input_url');
            input_url.value = file.name;
            this.setState({ browse_disabled: true })
            await this.uploadFile(value);
        }
    }

    async uploadFile(value) {
        if (value) {
            let file = value.target.files[0];
            // Need to better handle error cases
            this.setState({ selectedFile: file });
            const formData = new FormData();
            formData.append("file", file);
            formData.append("name", file.name);

            const client = await api.getClient();
            try {
                this.setState({ uploadInProgress: true });
                // potentially long-running operation
                const res = await client.create_upload_file_api_v1_uploadfile_post(null, formData, { baseURL: API_BASE_URL, onUploadProgress: this.dumpUploadProgress.bind(this) });

                this.props.onFileUploaded(
                    res.data['file_id'],
                    file.name
                );
                this.setState({ uploadedFileMessage: 'File ' + file.name + ' uploaded successfully!' });
                this.setState({ uploadInProgress: false });
                this.setState({ browse_disabled: false })
            }
            catch {
                this.props.onFileUploaded();
                this.setState({ uploadInProgress: false });
                this.setState({ uploadedFileMessage: 'Error during upload! Try again!' });
                this.setState({ browse_disabled: false })
                console.log('Error in upload');
            }
        }
    }

    render() {
        return (
            <div className="Upload-zone" >
                <div className="Upload-browse-and-upload">
                    <Form.Control
                        type="text"
                        placeholder="Please enter a URL or upload a file"
                        onChange={(value) => { this.onUrlTyping(value) }}
                        id="input_url"
                    />
                    {/* <label className="File-browse"> or </label> */}
                    <div className="Upload-button">
                        <input
                            type="file"
                            accept={Object.keys(VALID_FILES_AND_FORMATS)}
                            className="custom-file-input d-none"
                            id="inputGroupFile03"
                            onChange={async (value) => { this.onUploadClicked(value) }}
                        ></input>
                        {/* <label className="custom-file-label" htmlFor="inputGroupFile03">{this.state.selectedFile ? this.state.selectedFile.name : "Select a file from disk..."}</label> */}
                        <button onClick={this.openBrowseDialog} className="btn btn-primary" disabled={this.state.browse_disabled}>Browse...</button>
                    </div>
                </div>

                <div>
                    {this.state.uploadProgress > 0 && this.state.uploadProgress < 100 &&
                        <ProgressBar now={this.state.uploadProgress ? this.state.uploadProgress : 0} label={`${this.state.uploadProgress}%`} />
                    }
                </div>
            </div>
        )
    }
}

// Just unused for the moment

const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
        {props.text}
    </Tooltip>
);
class JobOptions extends React.Component {

    setSuite(index, event) {
        console.log('Got Suite ' + this.props.suites[index].name + ' ' + index);
        this.props.onSelectedSuite(this.props.suites[index]);
    }

    setFormat(index, event) {
        console.log('Got Format ' + this.props.formats[index].name + ' ' + index);
        this.props.onSelectedFormat(this.props.formats[index]);
    }

    componentDidMount() {
        this.props.onSelectedFormat(this.props.formats[0]);
        this.props.onSelectedSuite(this.props.suites[0]);
    }

    beautify(label) {
        let joined = label.split("_").join(" ")
        return joined.charAt(0).toUpperCase() + joined.slice(1);
    }

    render() {
        return (
            <div className="Job-options-zone">
                <div className="Job-options-title">
                    <Form.Label>Job Options</Form.Label>
                </div>
                <div className="Job-options-input">
                    <Row className="format-selector">
                        <Col md={2}>
                            Select Format:
                        </Col>
                        <Col md={2}>
                            {this.props.selected_format &&
                                <DropdownButton
                                    id="dropdown-item-button"
                                    title={this.props.selected_format.name}
                                >
                                    {this.props.formats.map((format, index) => (
                                        < Dropdown.Item
                                            as="button"
                                            key={format.name}
                                            eventKey={index}
                                            onSelect={(ek, e) => { this.setFormat(ek, e) }}
                                        > {format.name}</Dropdown.Item>
                                    ))
                                    }
                                </DropdownButton>
                            }
                        </Col>
                        <Col className="ss-c3"></Col>
                        <Col className="ss-c4"></Col>
                    </Row>
                    <Row className="suite-selector">
                        <Col md={2}>
                            Select Suite:
                        </Col>
                        <Col md={{ span: 2 }}>
                            {this.props.selected_suite &&

                                <DropdownButton
                                    id="dropdown-item-button"
                                    title={this.props.selected_suite.name}
                                >
                                    {this.props.suites.map((suite, index) => (
                                        <OverlayTrigger
                                            placement="auto"
                                            delay={{ show: 500, hide: 200 }}
                                            overlay={renderTooltip({ text: suite.description })}
                                        >
                                            < Dropdown.Item
                                                as="button"
                                                key={suite.name}
                                                eventKey={index}
                                                onSelect={(ek, e) => { this.setSuite(ek, e) }}
                                            > {suite.name}</Dropdown.Item>
                                        </OverlayTrigger>

                                    ))
                                    }
                                </DropdownButton>
                            }
                        </Col>

                    </Row>

                    {Object.keys(this.props.suiteDescription.options).map((option_name, index) => (
                        <Row>
                            <Col>
                                <Form.Check className='d-flex align-items-center'
                                    type="checkbox"
                                    label={this.beautify(option_name)}
                                    defaultChecked={this.props.suiteDescription.options[option_name]}
                                    onChange={(value) => {
                                        let suitedescription = this.props.suiteDescription;
                                        suitedescription.options[option_name] = value.currentTarget.checked;
                                        this.props.onSuiteDescription(suitedescription);
                                    }} />
                            </Col>
                        </Row>
                    ))
                    }

                </div>
            </div >
        );
    }
}

class LaunchJobButton extends React.Component {

    async launchJob() {
        const client = await api.getClient();
        try {
            // The following line is apparently how you shallow clone objects in JS
            var verify_post_body = { ...this.props.suiteDescription };
            verify_post_body.filepath = [this.props.suiteDescription.filepath];
            const res = await client.verify_api_v1_verify_post(null, verify_post_body, { baseURL: API_BASE_URL, });
            this.props.onJobLaunched(res.data['job_id']);
            this.setState({ disabled: true });
        }
        catch {
            console.log('Verify failed');
        }
    }

    render() {
        return (<>
            <style type="text/css">
                {`

    .btn-xxl {
      padding: 1rem 1.5rem;
      align-self: center;
      max-width: 960px;
    }
    `}
            </style>
            <Button
                variant="primary" size="xxl"
                disabled={this.props.disabled}
                onClick={() => this.launchJob()}
            >Launch Validation</Button>{' '}
        </>
        );
    }
}

class JobReportHeader extends React.Component {

    render() {
        if (this.props.status.error) {
            return (
                <div className="JobReport-header">
                    <div>
                        ERROR: {this.props.status.error}
                    </div>
                    <ProgressBar padding-top="5px" padding-bottom="5px" now={100} />
                </div>
            );
        }
        else if (this.props.status.result.error) {
            return (
                <div className="JobReport-header">
                    <div>
                        ERROR: {this.props.status.result.error}
                    </div>
                    <ProgressBar padding-top="5px" padding-bottom="5px" now={100} />
                </div>
            );
        }
        else {
            if (this.props.suites) {
                const format_folder = this.props.status.result.validation_suite_format;
                const suite_folder = this.props.status.result.validation_suite_name;

                const suite_name = folder_to_name(this.props.suites, suite_folder);
                const format_name = folder_to_name(this.props.formats, format_folder);
                return (
                    <div className="JobReport-header">
                        <div>
                            Validation Format: {format_name}
                        </div>
                        <div>
                            Validation Suite: {suite_name}
                        </div>
                        <ProgressBar padding-top="5px" padding-bottom="5px" now={this.props.status.result.progress ? this.props.status.result.progress : 0} label={`${this.props.status.result.progress}%`} />
                    </div>
                );
            } else {
                return null;
            }
        }

    }
}

// This is needed by the JsonTreeView, used to render the parsing results
// JSON.
// The only way to execute some Javascript that renders directly to a DOM
// element is to create a functional component, then use the "useEffect"
// hook, that executes after rendering.
// from the useEffect hook, you can use "ref" to get the current element
// to be passed to jsonview. This is equivalent to using something like
// document.querySelector.
const Observer = ({ value, index }) => {

    const ref = useRef(null);

    useEffect(() => {
        const element = ref.current;
        const tree = jsonview.create(value);
        // render tree into dom element
        jsonview.render(tree, element);

    }, [value])
    return (
        <div ref={ref} className="Task-report tr-c2 tr-info" id={'jsontree' + index}>

        </div>
    )
}

class TaskReport extends React.Component {
    constructor(props) {
        super(props);
        // Make the Task visible immediately if it contains nested suites
        this.state = {
            show_details: false || this.props.nested_suites.length,
        }
    }
    render() {
        const is_fail = (this.props.status.must_fix_issues.length) > 0;
        const is_warning = (this.props.status.must_fix_issues.length) === 0 && (this.props.status.should_fix_issues.length) > 0;
        const is_pass = (this.props.status.must_fix_issues.length) === 0 && (this.props.status.should_fix_issues.length) === 0;

        console.log(this.props.nested_suites);

        return (
            <div className="Task-report" key={this.props.index}>
                <div className="Task-report-row r1">
                    <div className="Task-report c1">
                        { // Task in progress, no errors
                            (this.props.progress < 100) && this.props.execution_error === "" &&
                            <Spinner
                                className="align-items-center"
                                animation="border"
                                variant="primary"
                            />}

                        { // Task finished, no execution errors, MP4 file has passed
                            (this.props.progress >= 100) && (this.props.execution_error === "") && is_pass && <img className="Green-ok" src={green_ok} alt="OK" />
                        }

                        { // Task finished, no execution errors, MP4 file has warnings
                            (this.props.progress >= 100) && (this.props.execution_error === "") && is_warning && <img className="Red-ko" src={yellow_warning} alt="WARNING" />
                        }

                        { // Task finished, no execution errors, MP4 file has failed
                            (this.props.progress >= 100) && (this.props.execution_error === "") && is_fail && <img className="Red-ko" src={red_ko} alt="KO" />
                        }

                        { // Task finished, execution errors
                            !(this.props.execution_error === "") &&
                            < img className="Crash" src={crash} alt="CRASH" />
                        }
                    </div>

                    <div className="Task-report c2">
                        {this.props.doc_link === "" && this.props.name}

                        {this.props.doc_link !== "" && <a href={this.props.doc_link} target="_blank" rel="noreferrer">{this.props.name}</a>}
                    </div>

                    <div className="Task-report c3">
                        {
                            // On Job finished, show button to have details
                            (this.props.progress >= 100) &&
                            <Button
                                onClick={() => this.setState({ show_details: !this.state.show_details })}
                                aria-controls="example-collapse-text"
                                aria-expanded={this.state.show_details}
                            >Details</Button>
                        }
                    </div>


                </div>

                <div className="Task-report-row r2">
                    <div className="Task-report c1"></div>
                    <Collapse in={this.state.show_details}>
                        <div className="Task-report c2" id="example-collapse-text">

                            {this.props.status.must_fix_issues.map((must_fix, index) => (
                                <div className="tr-r2" id={'tr-e' + index}>
                                    <div className="Task-report tr-c1 tr-must-fix" id={'tr-e-c1' + index}>
                                        MUST FIX:
                                    </div>
                                    <div className="Task-report tr-c2 tr-must-fix" id={'tr-e-c2' + index}>
                                        {must_fix}
                                    </div>
                                </div>
                            ))
                            }

                            {this.props.status.should_fix_issues.map((should_fix, index) => (
                                <div className="tr-r2" id={'tr-w' + index}>
                                    <div className="Task-report tr-c1 tr-should-fix" id={'tr-w-c1' + index}>
                                        SHOULD FIX:
                                    </div>
                                    <div className="Task-report tr-c2 tr-should-fix" id={'tr-w-c2' + index}>
                                        {should_fix}
                                    </div>
                                </div>
                            ))
                            }

                            {this.props.status.infos.map((info, index) => (
                                <div className="tr-r2" id={'tr-i' + index}>
                                    <div className="Task-report tr-c1 tr-info" id={'tr-i-c1' + index}>
                                        INFO:
                                    </div>
                                    <div className="Task-report tr-c2 tr-info" id={'tr-i-c2' + index}>
                                        {info}
                                    </div>
                                </div>
                            ))
                            }

                            {this.props.nested_suites && this.props.nested_suites.map((_status, index) => (
                                <div className="tr-r2" id={'tr-i' + index}>
                                    <div className="Nested-report tr-c1" id={'tr-i-c1' + index}>
                                        <JobReport
                                            suites={this.props.suites}
                                            formats={this.props.formats}
                                            jobStatus={{ result: _status }}
                                            enable_display={true}
                                        />
                                    </div>
                                </div>
                            ))
                            }

                            {this.props.status.data.map((datum, index) => (
                                <div className="tr-r2" id={'tr-i' + index}>
                                    <div className="Task-report tr-c1 tr-info" id={'tr-i-c1' + index}>
                                        INFO:
                                    </div>
                                    <Observer value={datum} index={index} />
                                </div>
                            ))
                            }

                            {this.props.execution_error && (
                                <div className="tr-r2" id={'tr-rt'}>
                                    <div className="Task-report tr-c1 tr-crash" id={'tr-rt-c1'}>
                                        RUNTIME ERROR:
                                    </div>
                                    <div className="Task-report tr-c2 tr-crash" id={'tr-rt-c2'}>
                                        {this.props.execution_error}
                                    </div>
                                </div>
                            )}

                        </div>
                    </Collapse>
                    <div className="Task-report c3"></div>
                </div>

            </div>
        );
    }
}

class JobReport extends React.Component {

    render() {
        const status = this.props.jobStatus;
        if (status && this.props.enable_display) {
            const { validation_tasks_progress } = status.result;
            const { validation_tasks_outcome } = status.result;
            const { execution_errors } = status.result;
            const { validation_tasks_doc_link } = status.result;
            const { nested_suites_status } = status.result;
            return (
                <div className="Job-report">
                    <JobReportHeader
                        suites={this.props.suites}
                        formats={this.props.formats}
                        status={status} />
                    {!status.result.error &&
                        Object.keys(validation_tasks_outcome).map((key, index) => (
                            <TaskReport
                                key={index} //needed by React
                                index={index}
                                name={key}
                                progress={validation_tasks_progress[key]}
                                status={validation_tasks_outcome[key]}
                                execution_error={execution_errors[key]}
                                doc_link={validation_tasks_doc_link[key]}
                                nested_suites={nested_suites_status[key]}
                                suites={this.props.suites}
                                formats={this.props.formats}
                            />
                        ))
                    }
                </div>
            );
        }
        else {
            return null;
        }
    }
}

class DownloadReportButton extends React.Component {

    async downloadReport() {
        const client = await api.getClient();
        try {
            const res = await client.get_report_api_v1_report__jobid__get(this.props.jobId, null, { baseURL: API_BASE_URL, });
            const blob = new Blob([res.data]);
            const fileDownloadUrl = URL.createObjectURL(blob);
            this.props.onReportReady(fileDownloadUrl);
        }
        catch {
            console.log('Error while trying to download report');
        }
    }

    render() {
        if (this.props.enabled) {
            return (
                <Button
                    variant="primary"
                    onClick={() => this.downloadReport()}
                >Download Report...</Button>
            );
        }
        else {
            return null;
        }
    }
}

class Header extends React.Component {
    render() {
        return (
            <nav className="bg-dark-usp navbar navbar-expand-lg navbar-dark">
                <div className="container">
                    <div className="navbar-header">
                        <a className="navbar-brand" href="http://www.unified-streaming.com">
                            <img className="App-logo logo" src={logo} alt="logo" />
                            <img className="App-logo text" src={unified_streaming} alt="Unified Streaming" />
                        </a>
                    </div>
                    <button className="navbar-toggler mr-1" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div id="navbar" className="navbar-collapse collapse">
                        <ul className="navbar-nav ml-auto">
                            <li className="nav-item"><a className="nav-link" href="docs/about.html">About</a></li>
                            <li className="nav-item"><a className="nav-link" href="docs/user_guide.html">User Guide</a></li>
                            <li className="nav-item"><a className="nav-link" href="docs/available_suites/index.html">Suites</a></li>
                            <li className="nav-item"><a className="nav-link" href="docs/FAQ.html">FAQ</a></li>
                        </ul>

                    </div>

                </div>
            </nav>
        );
    }
}

class Footer extends React.Component {
    render() {
        return (
            <div className="container">
                <footer className="mt-3 footer">
                    <div className="text-center">
                        <p>Questions about the Validator? Consult <a href="docs/user_guide.html">our guide</a> or  <a href="mailto:support@unified-streaming.com?subject=Validator">Contact Us</a>.
                            More information about Unified Streaming is available on our <a href="https://www.unified-streaming.com">website</a>.
                        </p>
                        <p> Version {getGitRevision()} ; <a href="https://www.unified-streaming.com/privacy">Privacy policy.</a></p>
                    </div>
                </footer>
            </div>
        );
    }
}

class GetSharableLinkSuccessMessage extends React.Component {
    render() {
        if (this.props.enabled) {
            setTimeout(
                () => {
                    this.props.onClose();
                }, 2000
            );
            return (
                <Alert transition="Fade" variant="success" dismissible onClose={() => this.props.onClose()}>
                    URL {`${window.location.href}`} successfully copied to clipboard!
                </Alert>
            );
        }
        else {
            return null;
        }
    }
}

class App extends React.Component {
    constructor(props) {
        super(props);
        // Get query params that could be needed for the initial state
        let search = new URLSearchParams(this.props.location.search);
        const input_file_url = search.get("url");
        const suite = search.get("suite");
        // Initial state, a minimum to draw a functional interface
        this.state = {
            queryParamUrl: input_file_url,
            queryParamSuite: suite,
            currentState: "start",
            jobId: null,
            suites: [{ name: "", folder: "", description: "" , options: ""}],
            selected_suite: { name: "", folder: "", description: "" },
            formats: [{ name: "", folder: "", description: "" }],
            selected_format: { name: "", folder: "", description: "" },
            suiteDescription: {
                validation_suite_format: '',
                validation_suite_name: '',
                filepath: null,
                filename: null,
                options: { "include_parsing_results": false, "stop_on_first_error":false}
            },
            jobStatus: null,
            fileDownloadUrl: null,
            fileDownloadName: "report.txt",
            attemptBeforeFail: 10,
            launch_enabled: false,
            copy_success_enabled: false,
        };
    }

    initialState() {
        this.setState({
            currentState: "start",
            jobId: null,
            jobStatus: null,
            fileDownloadUrl: null,
            fileDownloadName: "report.txt",
            attemptBeforeFail: 10,
            launch_enabled: false,
            copy_success_enabled: false,
        })
        this.props.history.push({
            pathname: `${this.props.location.pathname}`
        })
    }

    setErrorState() {
        this.setState({
            jobStatus: {
                error: "Cannot retrieve job status. Check your network connection and retry.",
                result: {
                    validation_tasks_progress: [],
                    validation_tasks_outcome: [],
                    execution_error: [],
                    nested_suites: []
                }
            }
        })
    }

    onFileUploaded(path, filename) {
        if (path) {
            let suitedescription = this.state.suiteDescription;
            suitedescription.filepath = path;
            suitedescription.filename = filename;
            this.initialState();
            this.setState({ suiteDescription: suitedescription });
            this.setState({ currentState: "launch_enabled" });
            this.setState({ launch_enabled: true });
            this.setState({ fileDownloadName: filename + '.txt' })
            this.setState({ copy_success_enabled: false });
        }
        else {
            this.initialState();
        }
    }

    onJobLaunched(id) {
        this.setState({ jobId: id });
        this.setState({ currentState: "job_pending" });
        this.setState({ attemptBeforeFail: 10 });
        this.setState({ copy_success_enabled: false });
    }

    onSuiteDescription(suitedescription) {
        this.setState({ suiteDescription: suitedescription });
        this.onFileUploaded(this.state.suiteDescription.filepath, this.state.suiteDescription.filename);
        console.log('Job Options Set! ', suitedescription);
    }

    onGetSharableLink() {
        this.setState({ copy_success_enabled: true });
    }

    onDismissSharableLinkSuccessMessage() {
        this.setState({ copy_success_enabled: false });
    }

    async onSelectedFormat(selected_format) {
        console.log(selected_format)
        if (selected_format) {
            if (selected_format === this.state.selected_format) {
                return
            }
            this.selectFormat(selected_format);
            // After getting the format list, suites must be updated too
            await this.getSuites(selected_format.folder);
        }
    }

    selectFormat(format) {

        let suitedescription = this.state.suiteDescription;
        suitedescription.validation_suite_format = format.folder;

        this.setState({ suiteDescription: suitedescription });
        this.setState({ selected_format: format });
        console.log('Format Selected! ', suitedescription);
    }

    async onSelectedSuite(selected_suite) {
        if (selected_suite) {
            if (selected_suite === this.state.selected_suite) {
                return
            }
            this.selectSuite(selected_suite);
            this.onFileUploaded(this.state.suiteDescription.filepath, this.state.suiteDescription.filename);
        }
    }

    selectSuite(suite) {
        let suitedescription = this.state.suiteDescription;
        if (suite) {
            suitedescription.validation_suite_name = suite.folder;
            suitedescription.options = suite.options;
        }
        else {
            suitedescription.validation_suite_name = '';
        }

        this.setState({ suiteDescription: suitedescription });
        this.setState({ selected_suite: suite });
        this.setState({ copy_success_enabled: false });
        console.log('Suite Selected! ', suitedescription);
    }

    isInputFileFromURL() {
        const suitedescription = this.state.suiteDescription;
        return (suitedescription.filename && suitedescription.filename === suitedescription.filepath)
    }

    onJobProgress(status) {

        console.log('OnJobProgress called');

        // Trick: in case of job pending or not run, the backend will report
        // a suite class and name equal to "unknown". But the UI actually knows
        // them, so we will overwrite them here. I know, it sucks.
        if (status.result && (
            status.result.validation_suite_format === 'unknown'
            || status.result.validation_suite_name === 'unknown')) {
            status.result.validation_suite_format = this.state.suiteDescription.validation_suite_format;
            status.result.validation_suite_name = this.state.suiteDescription.validation_suite_name;
        }

        // Check if max retries has been reached
        if (this.state.attemptBeforeFail === 0 || status.state === "ERROR") {
            this.setErrorState();
            this.setState({ currentState: "job_finished_error" });
        }
        // If Job did not yet kick in, or job id was not valid, or backend
        // not reachable, just count a failed attempt
        else if (status.state === "PENDING") {
            this.setState({ attemptBeforeFail: this.state.attemptBeforeFail - 1 });
        }
        else if (status.state === "STARTED") {
            // Enable Job Report
            this.setState({ currentState: "job_running" });
            this.setState({ jobStatus: status });
        }
        else if (status.state === "SUCCESS") {
            // Enable Job Report
            this.setState({ currentState: "job_finished_success" });
            this.setState({ jobStatus: status });
            // Update URL with query parameters with the current file URL
            // and suite. Do not do if the analyzed file was an upload
            // Keep current URL updated with DEFAULT SUITE
            if (this.isInputFileFromURL()) {
                let search = new URLSearchParams(this.props.history.search);
                search.set("suite", this.state.selected_suite.name);
                search.set("url", this.state.suiteDescription.filename);
                this.props.history.push({
                    pathname: `${this.props.location.pathname}`,
                    search: search.toString()
                })
            }
        }

        console.log('New status is ' + this.state.currentState);

    }

    onReportReady(url) {
        this.setState({ fileDownloadUrl: url });
        this.dofileDownload.click();
    }

    async fetchStatus() {
        if (this.state.currentState === "job_pending" || this.state.currentState === "job_running") {
            console.log('Fetching status');
            const client = await api.getClient();
            try {
                const res = await client.get_status_api_v1_status__jobid__get(this.state.jobId, null, { baseURL: API_BASE_URL, });
                this.onJobProgress(res.data);
            }
            catch {
                console.log('Verify failed');
                // Backend unreachable treated as a job pending. Will retry
                // and eventually fail
                this.onJobProgress({ state: "PENDING" })
            }
        }
    }

    async getFormats() {
        // The list of formats is populated at startup. By default, the first
        // format will be selected.
        // This is also responsible to retrieve the list of suites available
        // for the default format.
        const client = await api.getClient();
        try {
            const res = await client.get_formats_api_v1_formats_get(null, null, { baseURL: API_BASE_URL, });
            console.log(res.data.descriptors);
            if (res.status === 200) {
                this.setState({ formats: res.data.descriptors });
                this.onSelectedFormat(get_descriptor_by_name(res.data.descriptors, DEFAULT_FORMAT));
                // After getting the format list, suites must be updated too
                await this.getSuites(get_descriptor_by_name(res.data.descriptors, DEFAULT_FORMAT).folder);
            }
            else {
                console.log('Cannot get list of formats from backend!');
            }
        }
        catch {
            console.log('Cannot get list of formats from backend!');
        }
    }

    async getSuites(format) {
        if (format === '') {
            return
        }
        // Retrieves list of suites for a specific format.
        // Can be triggered by initial GUI setup when format is still
        // undefined (emtpy string)
        const client = await api.getClient();
        try {
            const res = await client.get_suites_api_v1__format__suites_get(format, null, { baseURL: API_BASE_URL, });
            console.log(res.data.descriptors);
            if (res.status === 200) {
                this.setState({ suites: res.data.descriptors });
                // If a query param is present, specifying a suite name, try
                // to use it (if it is valid). Otherwise use default
                //let search = new URLSearchParams(this.props.location.search);
                let selected_suite = get_descriptor_by_name(res.data.descriptors, DEFAULT_SUITE);

                //const qp_suite = search.get("suite");
                if (this.state.queryParamSuite) {
                    const suite_by_query = get_descriptor_by_name(res.data.descriptors, this.state.queryParamSuite);
                    if (suite_by_query) {
                        selected_suite = suite_by_query;
                    }
                    else {
                        console.log("The provided suite " + suite_by_query + " does not exist!");
                    }
                }

                this.onSelectedSuite(selected_suite);
            }
            else {
                console.log('Cannot get list of suites from backend!');
            }
        }
        catch {
            console.log('Cannot get list of suites from backend!');
        }
    }

    async componentDidMount() {
        // Responsible to start the polling loop (used to get job status)
        // and to fetch from the backend the available list of formats
        // and suites.
        this.timer = setInterval(async () => this.fetchStatus(), 1000);
        await this.getFormats();

        // After mounting the component, check if an input file ULR was
        // specified or not in the query parameters
        // You cannot use the same logic to set the suite, because first it
        // needs to get the suite list from the backend.
        if (this.state.queryParamUrl) {
            let input_url = document.getElementById('input_url');
            this.onFileUploaded(this.state.queryParamUrl, this.state.queryParamUrl);
            input_url.value = this.state.queryParamUrl;
        }
    }

    render() {
        return (
            <div className="App">

                <Header></Header>

                <div className="App-body">
                    <div className="title">Unified Validator</div>
                    <div className="col-md-12 pb-3">
                        <div className="bs-callout">
                            <h4>
                                Validator runs a set of checks against an MP4
                                of your choice. You can use it to validate
                                your content's compatibility with Unified
                                Streaming's streaming solutions using the
                                'Best Practices' suite, which is selected by
                                default, or you can choose any of the other
                                suites to validate your content's compliance
                                with relevant industry specifications.
                            </h4>
                        </div>
                    </div>
                    <UploadButton
                        onFileUploaded={(path, filename) => this.onFileUploaded(path, filename)}
                        formats={this.state.formats}
                        onSelectedFormat={(format) => this.onSelectedFormat(format)}
                        inputTextContent={this.state.queryParamUrl}
                    />
                    <p></p>
                    <JobOptions
                        suites={this.state.suites}
                        selected_suite={this.state.selected_suite}
                        formats={this.state.formats}
                        selected_format={this.state.selected_format}
                        suiteDescription={this.state.suiteDescription}
                        onSuiteDescription={(suitedescription) => this.onSuiteDescription(suitedescription)}
                        onSelectedSuite={(suite) => this.onSelectedSuite(suite)}
                        onSelectedFormat={(format) => this.onSelectedFormat(format)}
                    />
                    <p></p>
                    <LaunchJobButton
                        disabled={!(this.state.launch_enabled)}
                        suiteDescription={this.state.suiteDescription}
                        onJobLaunched={(id) => this.onJobLaunched(id)} />
                    <p></p>
                    <JobReport
                        suites={this.state.suites}
                        formats={this.state.formats}
                        jobStatus={this.state.jobStatus}
                        enable_display={this.state.currentState === "job_running" || this.state.currentState === "job_finished_success" || this.state.currentState === "job_finished_error"}
                    />
                    <p></p>
                    <div className="Post-Job-Buttons">
                        <div className="reportLink">
                            <DownloadReportButton
                                enabled={this.state.currentState === "job_finished_success"}
                                jobId={this.state.jobId}
                                onReportReady={(url) => this.onReportReady(url)}
                            />
                            <a className="hidden"
                                href={this.state.fileDownloadUrl}
                                ref={e => this.dofileDownload = e}
                                download={this.state.fileDownloadName}
                            >download it</a>
                        </div>
                        <div className="reportLink">
                            {this.state.currentState === "job_finished_success" && this.isInputFileFromURL() &&
                                <CopyToClipboard
                                    text={`${window.location.href}`}
                                    onCopy={() => this.onGetSharableLink()}
                                >
                                    <button className="btn btn-primary">Get Sharable Link</button>
                                </CopyToClipboard>
                            }
                        </div>
                    </div>
                    <GetSharableLinkSuccessMessage
                        enabled={this.state.copy_success_enabled}
                        onClose={() => this.onDismissSharableLinkSuccessMessage()}
                    />
                </div >
                <Footer></Footer>

            </div >
        );
    }
}

export default withRouter(App)
